// src/components/OperationNotification.tsx
import React, { useEffect } from 'react';
import { notification, Progress } from 'antd';
import {Operation} from "../../types";

interface OperationNotificationProps {
    operation: Operation;
}

const OperationNotification: React.FC<OperationNotificationProps> = ({ operation }) => {
    // Используем operation.id как ключ для уведомления.
    const key = operation.id;

    // Функция для формирования описания уведомления в зависимости от статуса.
    const getDescription = () => {
        if (operation.status === 'InProgress') {
            return (
                <div>
                    <p>{operation.errorMessage || 'Операция выполняется...'}</p>
                    {(
                        <Progress percent={operation.progress} size="small" status="active"/>
                    )}
                </div>
            );
        } else if (operation.status === 'Completed') {
            return <p>Операция завершена успешно.</p>;
        } else if (operation.status === 'Failed') {
            return <p>{operation.errorMessage || 'Операция завершилась с ошибкой.'}</p>;
        }
        return null;
    };

    useEffect(() => {
        // Обновляем уведомление каждый раз, когда меняются status, errorMessage или progress.
        notification.info({
            key,
            message: `Операция: ${operation.type}`,
            description: getDescription(),
            placement: 'topRight',
            duration: 0, // Не закрывать автоматически, пока операция InProgress.
        });

        // Если операция завершена (Completed или Failed), закроем уведомление через 3 секунды.
        if (operation.status !== 'InProgress') {
            const timer = setTimeout(() => {
                notification.destroy(key);
            }, 3000);
            return () => clearTimeout(timer);
        } else {
            return () => null;
        }
    }, [key, operation.status, operation.errorMessage, operation.progress, operation.type, getDescription]);

    return null;
};

export default OperationNotification;
